/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Users_I_Frame_WidthInputs */

const en_tables_users_i_frame_width = /** @type {(inputs: Tables_Users_I_Frame_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I Frame Width`)
};

const de_tables_users_i_frame_width = /** @type {(inputs: Tables_Users_I_Frame_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I Frame Breite`)
};

/**
* | output |
* | --- |
* | "I Frame Width" |
*
* @param {Tables_Users_I_Frame_WidthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_users_i_frame_width = /** @type {((inputs?: Tables_Users_I_Frame_WidthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Users_I_Frame_WidthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_users_i_frame_width(inputs)
	return de_tables_users_i_frame_width(inputs)
});